import { render } from "./ToxicologyTestsPreview.vue?vue&type=template&id=0cf1de8c"
import script from "./ToxicologyTestsPreview.vue?vue&type=script&lang=js"
export * from "./ToxicologyTestsPreview.vue?vue&type=script&lang=js"

import "./ToxicologyTestsPreview.vue?vue&type=style&index=0&id=0cf1de8c&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/panels/testsPreview/ToxicologyTestsPreview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0cf1de8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0cf1de8c', __exports__)) {
    console.log('reload')
    api.reload('0cf1de8c', __exports__)
  }
  
  module.hot.accept("./ToxicologyTestsPreview.vue?vue&type=template&id=0cf1de8c", () => {
    console.log('re-render')
    api.rerender('0cf1de8c', render)
  })

}


export default __exports__